import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Languages from './Languages'
import SiteIds from './SiteIds'
import Options from './Options'
import {ContextConsumer} from '../Context'

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: 'auto',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 2,
    '@media (max-width: 320px)': {
      display: 'none',
    },
  },
  flex: {
    flex: 1,
    fontWeight: 300,
    textTransform: 'capitalize',
  },
  menuButton: {
    marginLeft: -12,
  },
  avatar: {
    marginLeft: 3,
    cursor: 'pointer',
  },
  button: {
    marginLeft: theme.spacing.unit * 2,
    color: theme.palette.grey.contrastText,
    minHeight: 40,
    '&:hover': {
      backgroundColor: theme.palette.grey.main,
    },
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  icon: {
    marginRight: theme.spacing.unit,
  },
})

const Header = ({classes}) => {
  return (
    <ContextConsumer>
      {context => {
        return (
          <AppBar className={classes.root}>
            <Toolbar>
              {!context.isMobile && (
                <Typography
                  variant="title"
                  color="inherit"
                  className={classes.flex}>
                  {`${context.domain} ${context.subDomain}`}
                </Typography>
              )}
              {!context.isMobile && !context.isDemo && <SiteIds />}
              {!context.isDemo && <Options />}
              <Languages />
            </Toolbar>
          </AppBar>
        )
      }}
    </ContextConsumer>
  )
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles, {withTheme: true})(Header)



// WEBPACK FOOTER //
// ./src/components/Header.js